module.exports = __webpack_public_path__ + "app/bento-components/video-list/media/icon.svg?14c2cca76e4cc7de9b1c64549a81f94b";